export default __webpack_public_path__ + "static/media/certificate-upload.2956c4f4.svg";